/* src/pages/ContactUs.js */

import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa";
import ContactForm from "../components/ContactForm";
import styles from "./Pages.module.css"; // CSS Module
import localStyles from "./ContactUs.module.css"; // Create this file for contact-specific styles

const planMessages = {
  basic: "I'm interested in the Basic monthly IT support plan. Please send me details about whether it fits my business.",
  standard: "I'm interested in the Standard monthly IT support plan. Please send me details about whether it fits my business.",
  premium: "I'm interested in the Premium monthly IT support plan. Please send me details about whether it fits my business.",
};

function Contact() {
  const location = useLocation();
  const selectedPlan = new URLSearchParams(location.search).get("plan")?.toLowerCase();
  const initialMessage = planMessages[selectedPlan] || "";
  const leadSource = selectedPlan ? `contact-page-plan-${selectedPlan}` : "contact-page";

  return (
    <div className={styles.pageSection}>
      <Helmet>
        <title>Contact Tharpe Industries | IT Services in Shreveport-Bossier</title>
        <meta
          name="description"
          content="Get in touch with Tharpe Industries for affordable, expert IT services in Shreveport-Bossier. I provide consulting, repair, managed services, cloud solutions, cybersecurity, and data backup."
        />
      </Helmet>
      <h2>Contact</h2>
      
      <div className={localStyles.contactIntro}>
        <p>
          Need IT help in Shreveport-Bossier? Send the details and I’ll respond with the next practical step.
        </p>
        <p>
          Use the form below, or call or email directly for service requests, quotes, and support questions.
        </p>
        <a href="#send-message" className={localStyles.messageAnchor}>Send a Message</a>
      </div>
      
      <div className={localStyles.contactContent}>
        <div className={localStyles.contactInfo}>
          <div className={localStyles.contactMethod}>
            <span className={localStyles.contactIconBadge} aria-hidden="true"><FaPhone className={localStyles.contactIcon} /></span>
            <div>
              <h3>Phone</h3>
              <p><a href="tel:+13186587801" className={localStyles.contactLink}>(318) 658-7801</a></p>
              <p className={localStyles.contactNote}>Available by appointment</p>
            </div>
          </div>
          
          <div className={localStyles.contactMethod}>
            <span className={localStyles.contactIconBadge} aria-hidden="true"><FaEnvelope className={localStyles.contactIcon} /></span>
            <div>
              <h3>Email</h3>
              <p><a href="mailto:support@tharpeindustries.com" className={localStyles.contactLink}>support@tharpeindustries.com</a></p>
              <p className={localStyles.contactNote}>All inquiries receive a response within 24 hours</p>
            </div>
          </div>
          
          <div className={localStyles.contactMethod}>
            <span className={localStyles.contactIconBadge} aria-hidden="true"><FaMapMarkerAlt className={localStyles.contactIcon} /></span>
            <div>
              <h3>Service Area</h3>
              <p>Serving all of Shreveport-Bossier and surrounding areas</p>
              <p className={localStyles.contactNote}>On-site and remote support available</p>
            </div>
          </div>
          
          <div className={localStyles.contactMethod}>
            <span className={localStyles.contactIconBadge} aria-hidden="true"><FaClock className={localStyles.contactIcon} /></span>
            <div>
              <h3>Hours</h3>
              <p>By appointment only</p>
              <p className={localStyles.contactNote}>Emergency support available 24/7</p>
            </div>
          </div>
        </div>
        
        <div id="send-message" className={localStyles.contactFormWrapper}>
          <h3>Send a Message</h3>
          <ContactForm leadSource={leadSource} initialMessage={initialMessage} />
        </div>
      </div>
    </div>
  );
}

export default Contact;
